
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(5(059|345|513)|7(097|323|591)|2535|2646|4102|4294|6290|8279|9836|9972)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
